import { CommonModule } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CanPipe } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import {
  AlertComponent,
  ButtonComponent,
  FormGroupComponent,
  MbsPopupType,
  ModalComponent,
  ModalFooterDirective,
  RadioComponent
} from 'mbs-ui-kit';
import { ConnectionLicenseType } from 'mbs-ui-shared@components/computers-shared/enums';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import { PermissionsEnum } from 'mbs-ui-shared@models';
import Computer from 'mbs-ui-shared@models/Computer';
import { ConnectionType } from 'mbs-ui-shared@models/ConnectionType';
import { map, shareReplay } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-remote-connection-web-license-select-modal-component',
  templateUrl: './remote-connection-web-license-select-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    CanPipe,
    NgbTooltipModule,
    FormGroupComponent,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    RadioComponent,
    ModalFooterDirective,
    CanPipe
  ]
})
export class RemoteConnectionWebLicenseSelectModalComponent {
  private computersFacade = inject(ComputersFacade);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public readonly alertType = MbsPopupType;
  public readonly permissionsEnum = PermissionsEnum;

  public limitRMMCEExceeded$ = this.computersFacade.checkRmmCeLimit().pipe(
    map((limit) => limit.limitExceeded),
    shareReplay(1)
  );
  public connectionLicenseType = ConnectionLicenseType;
  public computer: Computer;
  public type = ConnectionLicenseType.Backup;

  public get isUnix(): boolean {
    return Computer.isUnix(this.computer);
  }

  public get isVNCorSSH(): boolean {
    const type = this.baseModal.data.type;
    return type === ConnectionType.SSH || type === ConnectionType.VNC;
  }

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.computer = this.baseModal.data.computer;
    }
  }
}
